// import { yupResolver } from "@hookform/resolvers/yup";
import './Expert.scss';

import { ArrowForward } from '@mui/icons-material';
import { Button } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { buttonStyles, buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
import AuthContext from '../../../Contexts/AuthProvider';
import { DrawManExpertStep2, DrawStep1CompleterCompte, DrawStep2CompleterCompte, DrawStep3CompleterCompte, DrawStep4CompleterCompte, EnAttenteIconBienvStep, Icone1S1Expert, RectSVGBienv } from '../../../data/SVGs';
import useWindowSize from '../../../hooks/useWindowSize';
import { UpperCasePrenomNomFromAuth } from '../../../Utils/utils';

function ExpertStep0() {
    const { auth } = useContext(AuthContext);
    //const step=useStep();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    // get where they came from
    const commencer = async (e) => {
        e.preventDefault();
        navigate('/expert/completeProfile');
    };

    {/* const internDivStyle = {
        height: '50px',
        backgroundColor: '#555'
    };*/}

    return (
        <>
            <div
                style={{display:'flex',flexDirection:'row',gap:'20px',
                    background:'white',
                    alignItems: 'center',
                    paddingLeft:device=='desktop'?'70px':'16px',
                    paddingTop:device=='desktop'?'40px':'16px',
                    paddingRight:device=='desktop'?'0px':'16px',
                    alignSelf:'stretch',
                }}
            >
                <div className='GrandBoxExpert'>

                    <div className='BoxExpert1'>
                        <h5 className='Bienv'>{i18n.t('Bienvenue!')}</h5>
                        <h1 className='NameExpert'>{UpperCasePrenomNomFromAuth(auth?.nom,auth?.prenom)}</h1>
                    </div>

                    <div className='Pret'>
                        <h4 className='titlesociete'>
                            {i18n.t('Prêt pour votre prochaine grande opportunité ?')}
                        </h4>
                        <h6 className='Pret2'>
                            {i18n.t('Nous vous invitons à compléter votre profil afin de pouvoir activer votre compte et bénéficier de toutes les fonctionnalités offertes par la plateforme.')}
                        </h6>
                    </div>

                    <div className='Steps'>
                        <div className='Step1'>
                            <div className='I1'>
                                <Icone1S1Expert />
                            </div>
                            <DrawStep1CompleterCompte />
                            <h6 className='titleI1'>{i18n.t('Profil')}</h6>
                        </div>
                        <div className='Step1'>
                            <div className='I1'>
                                <EnAttenteIconBienvStep/>
                                {/*<CheckIconBienvStep/>*/}
                            </div>
                            <DrawStep2CompleterCompte/>
                            <h6 className='titleI1'>{i18n.t('Données CV')}</h6>
                        </div>
                        <div className='Step1'>
                            <div className='I1'>
                                <EnAttenteIconBienvStep/>
                            </div>
                            <DrawStep3CompleterCompte />
                            <h6 className='titleI1'>{i18n.t('Préférences')}</h6>
                        </div>
                        <div className='Step1'>
                            <div className='I1'>
                                <EnAttenteIconBienvStep/>
                            </div>
                            <DrawStep4CompleterCompte />
                            <h6 className='titleI1'>{i18n.t('Société')}</h6>
                        </div>
                    </div>
                    <div className='BtnExpertComp'>
                        <Button
                            variant="contained"
                            onClick={commencer}
                            style={{...buttonStylesBlue(),...{width:device=='desktop' ?'182px':'100%'}}}
                            startIcon={<ArrowForward />}
                        >
                            {i18n.t('Commencer')}
                        </Button>
                        <Button
                            variant="text"
                            style={{...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}}}
                            onClick={() => navigate('/expert')}
                        >
                            {i18n.t('Remplir plus tard')}
                        </Button>

                    </div>
                </div>
                {device=='desktop' &&
                <>
                    <div
                        className='Man'
                        style={{zIndex:'2'}}
                    >
                        <DrawManExpertStep2 />
                    </div>
                    {/*a discuter (perturbe design)*/}
                    <div className='Man' >
                        <RectSVGBienv />
                    </div>
                </>
                }
            </div>

        </>
    );
}

export default ExpertStep0;

{/*
<motion.div
    className="col-md-6 offset-md-3"
    initial={{ x: '-100vw' }}
    animate={{ x: 0 }}
    transition={{ stiffness: 150 }}
>
    <h1>{'Bienvenue ' + auth?.email + ' !'}</h1>
    <h3>{'Prêt pour votre prochaine grande opportunite?'}</h3>
    <p>
        {' Nous vous invitons à compléter votre profil pour activer votre compte et accéder à toutes les foncionnalités de la plateforme'}
    </p>
    <div
        style={{
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'flex-start'
        }}
    >
        <div style={{ width: '20%' }}>
            <div style={internDivStyle} />
            <p>Profil</p>
        </div>
        <div style={{ width: '20%' }}>
            <div style={internDivStyle} />
            <p>{'Données CV'}</p>
        </div>
        <div style={{ width: '20%' }}>
            <div style={internDivStyle} />
            <p>{'Préférences'}</p>
        </div>
        <div style={{ width: '20%' }}>
            <div style={internDivStyle} />
            <p>{'Société'}</p>
        </div>

    </div>
    <Button
        variant="contained"
        onClick={commencer}
    >
        Commencer
    </Button>
    <Button variant="text">
        Remplir plus tard
    </Button>
</motion.div>*/}

